module.exports = __webpack_public_path__ + "static/media/sweatcoin_interpride.626a21b5.png";